import styles from "./Scene.module.css";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Input from "./../common/input/Input";
import Panorama from "./../../containers/panorama/Panorama";
import { useRef, useState } from "react";
import HotspotModal from "./../hotspot-modal/HotspotModal";
import { MdInfoOutline, MdDelete } from "react-icons/md";
import { useAppStore } from "../../hooks/store/useAppStore";
import {
  setActiveSceneSelector,
} from "../../hooks/store/setters";
import { activeSceneSelector, showHotspotModalSelector, tourActiveSceneIndexSelector } from "../../hooks/store/getters";
import { uploadScenePanoImage } from "./../../services/CloudStorage.service";
import { uploadSceneAudio } from './../../services/CloudStorage.service';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { removeSceneSelector } from "../../hooks/store/setters";
import { setConfirmModelSelector } from "../../hooks/store/setters";
import { activeSceneErrorSelector } from "../../hooks/store/getters";
import { useValidateForm } from "../../hooks/UseValidateForm";
import { changeHotspotPositionSelector } from "../../hooks/store/getters";

const renderAddHotspotTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Double click on the scene image to add new hotspot
  </Tooltip>
);

const WelcomeAudioUpload = ({ onUploaded }) => {
 
  const audioInputRef = useRef(null);
  const [progress, setProgress] = useState(null);

  const handleInputChange = async (event) => {
    const file = URL.createObjectURL(event.target.files[0]);
    const uploadCallback = url => onUploaded({ url, file });
    await uploadSceneAudio(event.target.files[0], setProgress, uploadCallback);
  };

  return (
    <Col md={4}>
      <div className={styles.formGroup}>
        <label className={styles.label}>Welcome Narration Audio</label>
        <Button
          variant="dark"
          block
          className={styles.sceneAudioUploadBtn}
          onClick={() => audioInputRef.current.click()}
          disabled={progress}
        >
          Upload Audio
          {progress ? (
            <ProgressBar animated now={progress} label={`${progress}%`} />
          ) : null}
        </Button>
        
        <input
          type="file"
          id="upload"
          hidden
          ref={audioInputRef}
          onChange={handleInputChange}
        />
      </div>
    </Col>
  );
};

const WelcomeAudioView = ( props ) => {
  const { audio } = props;
  const setActiveScene = useAppStore(setActiveSceneSelector);
  let playAudioFile = false;
  const audiPlayRef = useRef();

  const playAudio = () => {
    playAudioFile = !playAudioFile;
    playAudioFile ? audiPlayRef.current.play() : audiPlayRef.current.pause();
  };

  const deleteAudio = () => {
    setActiveScene({ audio: { file: null, url: "" } });
  };

  return (
    <Col md={6}>
      <div className={styles.formGroup}>
        <label className={styles.label}>Welcome Narration Audio</label>
        <Row>
          <Col xs={6}>
            <Button
              variant="warning"
              block
              className={styles.sceneAudioListenBtn}
              ref={audiPlayRef}
              onClick={playAudio}
            >
              Listen
            </Button>
            <audio src={audio.file} ref={audiPlayRef}></audio>
          </Col>
          <Col xs={6}>
            <Button
              variant="dark"
              block
              className={styles.sceneAudioUploadBtn}
              onClick={deleteAudio}
            >
              Delete
            </Button>
          </Col>
        </Row>
      </div>
    </Col>
  );
};

const WelcomeAudio = () => {
  const { audio } = useAppStore(activeSceneSelector);
  const setActiveScene = useAppStore(setActiveSceneSelector);

  const onUploaded = ({ file, url }) => {
    setActiveScene({ audio: { file, url } });
  };

  if (audio.url) return <WelcomeAudioView audio={audio} />;

  return <WelcomeAudioUpload onUploaded={onUploaded} />;
};

const Scene = () => {
  // const setShowHotspotModal = useAppStore(setShowHotspotModalSelector);
  const showHotspotModal = useAppStore(showHotspotModalSelector);
  const activeScene = useAppStore(activeSceneSelector);
  const setActiveScene = useAppStore(setActiveSceneSelector);
  const panoImageRef = useRef(null);
  const [progress, setProgress] = useState(null);
  const activeSceneIndex = useAppStore(tourActiveSceneIndexSelector);
  const setConfirmModel = useAppStore(setConfirmModelSelector);
  const activeSceneError = useAppStore(activeSceneErrorSelector);
  const removeScene = useAppStore(removeSceneSelector);
  const validateTour = useValidateForm();
  const changeHotspotPosition = useAppStore(changeHotspotPositionSelector);

  const inputChangeHandler = ({ target: { name, value } }) => {
      setActiveScene({ [name]: value });
      validateTour.validateScene({ name, value });
  };
  
  const handlePanTiltChange = ({ target: { name, value } }) => {
    console.log('handlePanTiltChange ', {name, value: parseFloat(value)});
    setActiveScene({ [name]: parseFloat(value) });
  }

  const handlePanoImage = async ({ target: { files } }) => {
    const [file] = files;
    const fileUrl = URL.createObjectURL(file);

    const fileUploadUrl = (url) => setActiveScene({ panoImage: { file: fileUrl, url } });

    setActiveScene({ panoImage: { file: fileUrl } });
  
    validateTour.validateScenePano({key:"url",value:fileUrl})

    await uploadScenePanoImage(file, setProgress, fileUploadUrl );
  };

  const deleteSceneConfirmModel = () => {
    const payload = { 
       show: true, 
       title:"Delete Scene", 
       text: "Are you sure want to delete the scene?", 
       cancelButtonText: "Cancel",
       successButtonText: "Delete",
       successCallback: deleteScene
    }
    setConfirmModel(payload);
  }

  const deleteScene = async() => {
    console.log('delete scene index',activeSceneIndex);
    setConfirmModel({ show: false })
    removeScene(activeSceneIndex);
  }
  
  if (!activeScene) return null;

  return (
    <div className={styles.scene}>
      <div className={styles.sceneHeader}>
        <div>
          <h2 className={styles.pageTitle}>Scene Configuration</h2>
          <span className={styles.pageSubtitle}>
            Enter scene details and upload 360 image
          </span>
        </div>
        <Button
          variant="danger"
          className={styles.deleteSceneBtn}
          onClick={deleteSceneConfirmModel}
          disabled={progress}
        >
          <MdDelete className="mr-1" />
          <span className={styles.delteSceneBtnText}>Delete Scene</span>
        </Button>
      </div>
      
      <div className={styles.sceneForm}>
        <Row>
          <Col md={6}>
            <Input
              label="Scene Name"
              name="name"
              value={activeScene.name}
              onChange={inputChangeHandler}
              error={activeSceneError?.name}
            />
          </Col>
          <WelcomeAudio />
          
        </Row>
        <Row>
          <Col md={12}>
            <Input
              type="textarea"
              label="Scene Description"
              name="description"
              value={activeScene.description}
              onChange={inputChangeHandler}
              error={activeSceneError?.description}
            />
          </Col>
        </Row>
      </div>

      {!activeScene.panoImage.url && (
        <div className={styles.sceneImage}>
          <Button
            variant="dark"
            className={styles.sceneImageUploadBtn}
            onClick={() => panoImageRef.current.click()}
            disabled={progress}
          >
            Upload 360 Image 
            
            {progress ? (
              <ProgressBar animated now={progress} label={`${progress}%`} />
            ) : null}
           
          </Button>
          <span style={{color: "red" }}> {activeSceneError.url} </span>
        </div>
      )}
      <input
        type="file"
        id="upload"
        hidden
        ref={panoImageRef}
        onChange={handlePanoImage}
      />
          
      { activeScene.panoImage.url && (
        <div className={styles.sceneConfiguration}>
          <Row>
            <Col md={6}>
              <Row>
                <Col sm={8}>
                  <Input
                    label="Default Zoom"
                    type="range" 
                    className="w-100" 
                    name="zoom"
                    value={activeScene.zoom}
                    min="1"
                    max="20"
                    onChange={handlePanTiltChange} 
                  />
                </Col>
                <Col sm={4}>
                  <Input
                    label="Value"
                    type="number" 
                    className="w-100" 
                    name="zoom"
                    value={activeScene.zoom}
                    min="1"
                    max="20"
                    onChange={handlePanTiltChange} 
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Row>
                <Col sm={8}>
                  <Input
                    label="Pan X-axis"
                    type="range" 
                    className="w-100" 
                    name="pan"
                    value={activeScene.pan}
                    min="-360"
                    max="360"
                    step="0.5"
                    onChange={handlePanTiltChange} 
                  />
                </Col>
                <Col sm={4}>
                  <Input
                    label="Value"
                    type="number" 
                    className="w-100" 
                    name="pan"
                    value={activeScene.pan}
                    min="-360"
                    max="360"
                    onChange={handlePanTiltChange} 
                  />
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row>
                <Col sm={8}>
                  <Input
                    label="Tilt Y-axis"
                    type="range" 
                    className="w-100" 
                    name="tilt"
                    value={activeScene.tilt}
                    min="-360"
                    max="360"
                    step="0.5"
                    onChange={handlePanTiltChange} 
                  />
                </Col>
                <Col sm={4}>
                  <Input
                    label="Value"
                    type="number" 
                    className="w-100" 
                    name="tilt"
                    value={activeScene.tilt}
                    min="-360"
                    max="360"
                    onChange={handlePanTiltChange} 
                  />
                </Col>
                
              </Row>
            </Col>
          </Row>
          <div>
            { changeHotspotPosition && (
              <span>
                Please double click on the scene to change the hotspot poistion
              </span>
            )}
          </div>
        </div>
      )}
       
       {activeScene.panoImage.url && (
        <div className={styles.scenePanorama}>
          <div className={styles.scenePanoramaControls}>
            <Button
              variant="dark"
              className={styles.sceneImageUploadBtn}
              onClick={() => panoImageRef.current.click()}
              disabled={progress}
            >
              Change Image
              {progress ? (
                <ProgressBar animated now={progress} label={`${progress}%`} />
              ) : null}
            </Button>
            

            <OverlayTrigger
              placement="bottom"
              delay={{ show: 150, hide: 500 }}
              overlay={renderAddHotspotTooltip}
            >
              <Button variant="light">
                <MdInfoOutline /> Hotspot
              </Button>
            </OverlayTrigger>
          </div>

          {activeScene.panoImage.url && <Panorama />}
          
        </div>
        )}
    

      { showHotspotModal && <HotspotModal /> }
    </div>
  );
};

export default Scene;
